import React from 'react';
import { BrowserRouter, Routes, Route, useParams, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Customers from './pages/Customers';
import SyncDetails from './pages/SyncDetails';
import FeaturesPage from './pages/FeaturesPage';
import LicensesPage from './pages/LicensesPage';
import SyncInstanceInformation from './pages/SyncInstanceInformation';

function ProtectedSyncDetails() {
  const { tenantInt, customerId } = useParams();
  
  if (!tenantInt || !customerId) {
    return <Navigate to="/customers" replace />;
  }
  
  const tenantIntValue = parseInt(tenantInt, 10);
  const customerIdValue = parseInt(customerId, 10);
  
  if (isNaN(tenantIntValue) || isNaN(customerIdValue)) {
    return <Navigate to="/customers" replace />;
  }
  
  return <SyncDetails />;
}

function ProtectedSyncInstanceInformation() {
  const { tenantInt, instanceId, customerId } = useParams();
  
  if (!tenantInt || !instanceId || !customerId) {
    return <Navigate to="/customers" replace />;
  }
  
  const tenantIntValue = parseInt(tenantInt, 10);
  const customerIdValue = parseInt(customerId, 10);
  
  if (isNaN(tenantIntValue) || isNaN(customerIdValue)) {
    return <Navigate to="/customers" replace />;
  }
  
  return <SyncInstanceInformation />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/sync-details/:tenantInt/:customerId" element={<ProtectedSyncDetails />} />
        <Route path="/features/:customerId" element={<FeaturesPage />} />
        <Route path="/licenses/:customerId" element={<LicensesPage />} />
        <Route path="/sync-instance/:tenantInt/:instanceId/:customerId" element={<ProtectedSyncInstanceInformation />} />
        <Route path="*" element={<Navigate to="/customers" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
